module.exports = __webpack_public_path__ + "static/not-auth-31c1f75d9e77961e6847cdcc70f2f24b.png";